import $ from 'jquery';

export default () => {
  $('.js-primary-menu').on('click', () => {
    $('.site-header').toggleClass('menu-is-open');
  });
};



// WEBPACK FOOTER //
// ./wp/wp-content/themes/ukrainian-museum-theme/src/scripts/modules/Menu.js